import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import mixpanel from 'mixpanel-browser';

import styles from '../../styles/preventivatore/NoResultsPreventivatore.module.css';

import addProductToRequest from '../../api/request/addProductToRequest.js';
import { track } from '../../utilities/trackerStatistics.js';

const NoResultsPreventivatore = ({ openPopup, selectedProduct, estimatorData, sendRequest, selectedFormData, resultsNumber }) => {
  const { t } = useTranslation();
  const [requestSent, setRequestSent] = useState(false);
  const [isWorkingTime, setIsWorkingTime] = useState(true);

  useEffect(() => {
    const hoursNow = moment().format('HH');
    const minutesNow = moment().format('mm');
    if (Number(hoursNow) >= 20 || Number(hoursNow) <= 7) {
      setIsWorkingTime(false);
    } else if (Number(hoursNow) === 19) {
      if (Number(minutesNow) > 30) {
        setIsWorkingTime(false);
      }
    } else if (Number(hoursNow) === 8) {
      if (Number(minutesNow) < 30) {
        setIsWorkingTime(false);
      }
    }
  }, []);

  useEffect(() => {
    if (selectedProduct.includes(0)) {
      setRequestSent(true);
    }
  }, [selectedProduct]);

  function makeRequest() {
    // const requestData = {
    //   type: 'mortgage',
    //   name: estimatorData && estimatorData.user && estimatorData.user.name ? estimatorData.user.name : "-",
    //   lastName: '-',
    //   email: estimatorData && estimatorData.user && estimatorData.user.email ? estimatorData.user.email : "-",
    //   date: new Date(),
    //   prefix: estimatorData && estimatorData.user && estimatorData.user.prefix ? estimatorData.user.prefix : "+39",
    //   phone: estimatorData && estimatorData.user && estimatorData.user.phone ? estimatorData.user.phone : "-",
    //   toc: true,
    //   message: '',
    //   product:
    //   estimatorData: estimatorData,
    // }

    const requestData = {
      reqid: estimatorData && estimatorData.reqid ? estimatorData.reqid : null,
      product: { prodottoId: '0', nomebanca: '-', rata: '0' },
    };
    // api to get list of results
    return addProductToRequest(requestData)
      .then(resp => {
        // // console.log('addRequest success', resp);
      })
      .catch(err => {
        // console.log('error addRequest', err);
        // setPopupRequest(true);
        // setPopupTitle(t('home.form_error_title'));
        // setPopupText(t('home.form_error_text'));
      });
  }

  return (
    <div className={styles.container}>
      <p className={styles.title}>{t('preventivatore.results_' + resultsNumber + '_title')}</p>
      <p className={styles.description}>{t('preventivatore.results_' + resultsNumber + '_description')}</p>
      <p className={styles.description}>{t('preventivatore.results_' + resultsNumber + '_description_2')}</p>

      {requestSent ? (
        <div className={styles.cta_container}>
          <div className={styles.requestDone}>
            {isWorkingTime
              ? 'La tua richiesta è stata inviata ai nostri consulenti, sarai ricontattato entro 5 minuti.'
              : 'La tua richiesta è stata inoltrata. Un nostro consulente ti ricontatterà appena possibile'}
          </div>
        </div>
      ) : (
        <div className={styles.cta_container}>
          <button
            onClick={() => {
              window.dataLayer.push({
                event: 'ottieni_mutuo',
                eventProps: estimatorData,
              });
              // mixpanel.track('verifica fattibilità', {
              //   no_results: true,
              // });
              track('verifica fattibilità', {
                no_results: true,
              });
              // makeRequest();
              openPopup('CONSULENZA');
            }}
            className="estimator-list-button">
            PARLA CON UN CONSULENTE
          </button>
          <div className="buttonsubline">GRATIS E SENZA IMPEGNO</div>
        </div>
      )}
    </div>
  );
};

export default NoResultsPreventivatore;
